import Action from '../action';

export const FETCH_ATTRIBUTES_BEGIN = 'FETCH_ATTRIBUTES_BEGIN';
export const FETCH_ATTRIBUTES_SUCCESS = 'FETCH_ATTRIBUTES_SUCCESS';
export const FETCH_ATTRIBUTES_FAILURE = 'FETCH_ATTRIBUTES_FAILURE';

export const FETCH_ATTRIBUTE_SECURITY = 'FETCH_ATTRIBUTE_SECURITY';
export const FETCH_ATTRIBUTE_SECURITY_SUCCESS = 'FETCH_ATTRIBUTE_SECURITY_SUCCESS';
export const FETCH_ATTRIBUTE_SECURITY_FAILURE = 'FETCH_ATTRIBUTE_SECURITY_FAILURE';

export const ATTRIBUTE_CREATED = 'ATTRIBUTE_CREATED';
export const ATTRIBUTE_REMOVED = 'ATTRIBUTE_REMOVED';

export const createAttribute = () => Action(ATTRIBUTE_CREATED);
export const removeAttribute = () => Action(ATTRIBUTE_REMOVED);

export const fetch = () => Action(FETCH_ATTRIBUTES_BEGIN);
export const fetchSuccess = payload => Action(FETCH_ATTRIBUTES_SUCCESS, payload);
export const fetchFailure = payload => Action(FETCH_ATTRIBUTES_FAILURE, payload, true);

export const fetchSecurity = () => Action(FETCH_ATTRIBUTE_SECURITY);
export const fetchSecuritySuccess = payload => Action(FETCH_ATTRIBUTE_SECURITY_SUCCESS, payload);
export const fetchSecurityFailure = payload => Action(FETCH_ATTRIBUTE_SECURITY_FAILURE, payload, true);
